import Vue from 'vue'
import VueRouter from 'vue-router'
import PCHome from '@/views/pc/home.vue'
import MHome from '@/views/m/home.vue'

import { IsPC } from '@/utils/util'

Vue.use(VueRouter)

const routesPc = [
  {
    path: '*',
    redirect: '/index'
  },
  {
    path: '/pc',
    name: 'PCHome',
    component: PCHome,
    children: [
      //首页
      {
        path: '/index',
        name: 'Index',
        component: () => import('../views/pc/index.vue')
      },
      //二十大
      {
        path: '/erShiDa',
        name: 'ErShiDa',
        component: () => import('../views/pc/list.vue')
      },
      //工作要闻
      {
        path: '/work',
        name: 'Work',
        component: () => import('../views/pc/list.vue')
      },
      //媒体发声
      {
        path: '/media',
        name: 'Media',
        component: () => import('../views/pc/list.vue')
      },
      //活动专区
      {
        path: '/active',
        name: 'Active',
        component: () => import('../views/pc/list.vue')
      },
      //视频专区
      {
        path: '/video',
        name: 'Video',
        component: () => import('../views/pc/list.vue')
      },
      //竞赛专区
      {
        path: '/jingSai',
        name: 'JingSai',
        component: () => import('../views/pc/list.vue')
      },
      //金融先进专区
      {
        path: '/dlamor',
        name: 'Dlamor',
        component: () => import('../views/pc/list.vue')
      },
      //资料下载
      {
        path: '/download',
        name: 'Download',
        component: () => import('../views/pc/list.vue')
      },
      //内容详情
      {
        path: '/info',
        name: 'Info',
        component: () => import('../views/pc/list.vue')
      },
      //视频播放
      {
        path: '/play',
        name: 'Play',
        component: () => import('../views/pc/play.vue')
      },
      //劳模工匠
      {
        path: '/laomo',
        name: 'Laomo',
        component: () => import('../views/pc/list.vue')
      },
      //创新成果
      {
        path: '/achievement',
        name: 'Achievement',
        component: () => import('../views/pc/list.vue')
      },
      //疗休养预约
      {
        path: '/lxyReserve',
        name: 'LxyReserve',
        component: () => import('../views/pc/lxyReserve.vue')
      },
    ]
  }
];

const routesM = [
  {
    path: '*',
    redirect: '/index'
  },
  {
    path: '/m',
    name: 'MHome',
    component: MHome,
    children: [
      //首页
      {
        path: '/index',
        name: 'Index',
        component: () => import('../views/m/index.vue')
      },
      //二十大
      {
        path: '/erShiDa',
        name: 'ErShiDa',
        component: () => import('../views/m/list.vue')
      },
      //工作要闻
      {
        path: '/work',
        name: 'Work',
        component: () => import('../views/m/list.vue')
      },
      //媒体发声
      {
        path: '/media',
        name: 'Media',
        component: () => import('../views/m/list.vue')
      },
      //活动专区
      {
        path: '/active',
        name: 'Active',
        component: () => import('../views/m/list.vue')
      },
      //视频专区
      {
        path: '/video',
        name: 'Video',
        component: () => import('../views/m/list.vue')
      },
      //竞赛专区
      {
        path: '/jingSai',
        name: 'JingSai',
        component: () => import('../views/m/list.vue')
      },
      //金融先进专区
      {
        path: '/dlamor',
        name: 'Dlamor',
        component: () => import('../views/m/list.vue')
      },
      //资料下载
      {
        path: '/download',
        name: 'Download',
        component: () => import('../views/m/list.vue')
      },
      //内容详情
      {
        path: '/info',
        name: 'Info',
        component: () => import('../views/m/list.vue')
      },
      //视频播放
      {
        path: '/play',
        name: 'Play',
        component: () => import('../views/m/play.vue')
      },
      //劳模工匠
      {
        path: '/laomo',
        name: 'Laomo',
        component: () => import('../views/m/list.vue')
      },
      //创新成果
      {
        path: '/achievement',
        name: 'Achievement',
        component: () => import('../views/m/list.vue')
      },
      //疗休养预约
      {
        path: '/lxyReserve',
        name: 'LxyReserve',
        component: () => import('../views/m/lxyReserve.vue')
      },
    ]
  }
];

const router = new VueRouter({
  routes: IsPC() ? routesPc : routesM
})
//页面跳转后页面置顶
router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router
